/*
 * @Author: xcy
 * @Date: 2022-01-18 16:35:15
 * @LastEditTime: 2022-01-19 16:07:52
 * @LastEditors: xcy
 * @Description: 
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        menuIndex: 0,
        isClickMenu: false
    },
    mutations: {
        setMeunIndex(state, data) {
            state.menuIndex = data;
        },
        isClickMeunHandle(state, data) {
            state.isClickMenu = data
        }
    },
    actions: {},
    modules: {},
});
